import { AllAffiliateReport } from '@core/models/all-affiliates-report.model';
import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { Injectable } from '@angular/core';

@Injectable()
export class AllAffiliateReportEntityService extends EntityCollectionServiceBase<AllAffiliateReport> {
  constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory) {
      super('AllAffiliateReport', serviceElementsFactory);
  }
}
